export default function (pageLocked = false, action) {
  if (action.type === "togglePageLocked") {
    return action.pageLocked;
  } else {
    return pageLocked;
  }
}
